import { driver } from 'driver.js';
import '../main.css';
import 'driver.js/dist/driver.css';
export const oneServerDriverObj = (dispatch) => {
  const driverObj = driver({
    showProgress: true,
    nextBtnText: 'Next',
    prevBtnText: 'Previous',
    doneBtnText: 'Done',
    popoverClass: 'driverjs-theme',
    steps: [
      {
        element: '.addOneServer',
        popover: {
          title: 'Add New Server',
          description:
            'Click here to add a new server. You can configure the server settings to fit your requirements before deployment.',
          side: 'left',
          align: 'start',
        },
      },
      {
        element: '.editOneServer',
        popover: {
          title: 'Edit Server Configuration',
          description:
            'Use this option to modify the settings of an existing server. Ensure that the changes align with your infrastructure needs.',
          side: 'left',
          align: 'start',
        },
      },
      {
        element: '.attachRegions',
        popover: {
          title: 'Attach Regions to Server',
          description:
            'Assign specific regions to this server to manage its availability and performance across different geographical areas.',
          side: 'left',
          align: 'start',
        },
      },
      {
        element: '.deleteOneServer',
        popover: {
          title: 'Delete Server',
          description:
            'Remove this server from your infrastructure. Make sure that it is no longer needed, as this action is irreversible.',
          side: 'left',
          align: 'start',
        },
      },
      {
        element: '.attachRegionsDetails',
        popover: {
          title: 'Region Attachment Details',
          description:
            'View the details of the regions attached to this server. This helps in understanding the server’s geographical deployment.',
          side: 'left',
          align: 'start',
        },
      },
      {
        element: '.oneServerMainTableData',
        popover: {
          title: 'Server Overview Table',
          description:
            'This table provides a comprehensive overview of the server’s configuration, attached regions, and status. Use this to monitor and manage your server effectively.',
          side: 'left',
          align: 'start',
        },
      },
    ],
  });
  return driverObj;
};
export default oneServerDriverObj;
